import translationsDa from '../config/translations_da.json';
import translationsEn from '../config/translations_en.json';
import translationsFi from '../config/translations_fi.json';
import translationsNo from '../config/translations_no.json';
import translationsSv from '../config/translations_sv.json';

/**
 * Creates a translation service for the given language code
 */
const createTranslateService = (languageCode: 'EN' | 'SV' | 'NO' | 'FI' | 'DA') => (key: string, data?: any) => {
    let translation = key;
    switch (languageCode) {
        case 'EN':
            translation = (translationsEn as any)[key];
            break;
        case 'SV':
            translation = (translationsSv as any)[key];
            break;
        case 'NO':
            translation = (translationsNo as any)[key];
            break;
        case 'FI':
            translation = (translationsFi as any)[key];
            break;
        case 'DA':
            translation = (translationsDa as any)[key];
            break;
    }

    // Default to the key if not found
    translation = translation ?? key;

    // Replace data in the string using placeholders
    for (const objectKey in data) {
        translation = translation.replace('{{' + objectKey + '}}', data[objectKey]);
    }
    return translation;
};

export default createTranslateService;
